module.exports = __webpack_public_path__ + "static/media/promo.0dd94455.png";